const forms = () =>
{
    let inputs = document.querySelectorAll('.input, .text-area, .select');

    inputs.forEach(function(input) {
        input.addEventListener('change', function() {
            if (input.value && input.value != null) {
                input.classList.add('bg-blue-light');
            } else {
                input.classList.remove('bg-blue-light');
            }
        });
    });

}

export { forms }
